export const FeatureFlagAmplitude = {
  // EDITOR_UNICO_NEW_GRID: 'editor_unico_new_grid', // live
  EDITOR_UNICO_TAGLI: 'editor_unico_tagli', // live
  EDITOR_UNICO_HEADER_V4: 'editor_unico_header_v4', // staging
  EDITOR_UNICO_DISABLE_POSTER_LOOKUPS: 'editor_unico_disable_poster_lookups', // staging
};

export const LOCAL_VARIANTS = {
  // [FeatureFlagAmplitude.EDITOR_UNICO_NEW_GRID]: {
  //   key: FeatureFlagAmplitude.EDITOR_UNICO_NEW_GRID,
  //   value: 'true',
  // },
  [FeatureFlagAmplitude.EDITOR_UNICO_TAGLI]: {
    key: FeatureFlagAmplitude.EDITOR_UNICO_TAGLI,
    value: 'false',
  },
  [FeatureFlagAmplitude.EDITOR_UNICO_HEADER_V4]: {
    key: FeatureFlagAmplitude.EDITOR_UNICO_HEADER_V4,
    value: 'false',
  },
  [FeatureFlagAmplitude.EDITOR_UNICO_DISABLE_POSTER_LOOKUPS]: {
    key: FeatureFlagAmplitude.EDITOR_UNICO_DISABLE_POSTER_LOOKUPS,
    value: 'true',
  },
};
